import { render, staticRenderFns } from "./TableIndex.vue?vue&type=template&id=2f681513&scoped=true&"
import script from "./TableIndex.vue?vue&type=script&lang=js&"
export * from "./TableIndex.vue?vue&type=script&lang=js&"
import style0 from "./TableIndex.vue?vue&type=style&index=0&id=2f681513&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f681513",
  null
  
)

export default component.exports